import axios from "axios";
import { getHeaders } from "../utils/main";
import endpoints from "./endpoints";

export const getProdutApi = async params => {
    const callResponse = await axios({
        url: endpoints.produtFetch,
        method: "get",
        headers: getHeaders(),
        params,
    })
        .then(response => response.data)
        .catch(err => ({ status: 0, response: err.response, code: err.response.status }));

    return callResponse;
};

export const CreateProductApi = async data => {
    const callResponse = await axios({
        url: endpoints.CreateProduct,
        method: "post",
        headers: getHeaders(),
        data,
    })
        .then(response => response.data)
        .catch(err => ({ status: 0, response: err.response, code: err.response.status }));

    return callResponse;
};

export const DeleteProductApi = async data => {
    const callResponse = await axios({
        url: endpoints.DeleteProduct,
        method: "delete",
        headers: getHeaders(),
        data,
    })
        .then(response => response.data)
        .catch(err => ({ status: 0, response: err.response, code: err.response.status }));

    return callResponse;
};

export const UpdateProductApi = async data => {
    const callResponse = await axios({
        url: endpoints.UpdateProduct,
        method: "patch",
        headers: getHeaders(),
        data,
    })
        .then(response => response.data)
        .catch(err => ({ status: 0, response: err.response, code: err.response.status }));

    return callResponse;
};

export const ProductFindByIdApi = async params => {
    const callResponse = await axios({
        url: endpoints.ProductById,
        method: "get",
        headers: getHeaders(),
        params,
    })
        .then(response => response.data)
        .catch(err => ({ status: 0, response: err.response, code: err.response.status }));

    return callResponse;
};